import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#040F3E',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '3px',
          fontFamily: 'Electrolux Sans',
          textDecorationLine: 'underline',
          textTransform: 'capitalize',
        },
      },
    },
  },
})
